import { CampaignPromoModal } from "app/components/discountCampaign/CampaignPromoModal/CampaignPromoModal";
import type { ICampaignPromoModalProps } from "app/components/discountCampaign/CampaignPromoModal/types";
import { useCampaignDismiss } from "app/components/discountCampaign/common/hooks/useCampaignDismiss";

import { useAeoCampaign } from "./useAeoCampaign";

const AEO_CAMPAIGN_MODAL_STORAGE_KEY = "aeo.campaign.modal.last.shown";
const AEO_TRACKING_PREFIX = "aeo campaign modal";

/** AEO campaign modal. Uses shared useCampaignPromoModal with AEO config. */
export const AeoCampaignModal = () => {
    const { aeoCtaType, onAeoCtaClick, discountModalProps } = useAeoCampaign();

    const modalInfo = useCampaignDismiss({
        type: "modal",
        isEligible: aeoCtaType !== null,
        onCtaClick: onAeoCtaClick,
        storageKey: AEO_CAMPAIGN_MODAL_STORAGE_KEY,
        trackingPrefix: AEO_TRACKING_PREFIX,
        ctaType: aeoCtaType,
    });

    if (!discountModalProps) {
        return null;
    }

    const modalProps: ICampaignPromoModalProps = {
        ...modalInfo,
        discountEndTime: discountModalProps.discountEndTime,
        ...discountModalProps.modalConfig,
    };

    return <CampaignPromoModal {...modalProps} />;
};
